import {ArrowDownOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {Radio} from "antd";
import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import CrossSectionFilter from "../CrossSectionFilter";

const DSUS = ({reverse}) => {
    return (
        <div style={{display: 'flex', alignItems: 'center', height:'100%'}}>
            <ArrowDownOutlined />
            {/*<SortAscendingOutlined />*/}
            <div style={{fontSize: '6pt', display: 'flex', flexDirection: 'column', lineHeight: '8px'}}>
                {
                    reverse && (
                        <>
                            <span style={{padding: 0}}>{'US'}</span>
                            <span style={{padding: 0}}>{'DS'}</span>
                        </>
                    )
                }
                {
                    !reverse && (
                        <>
                            <span style={{padding: 0}}>{'DS'}</span>
                            <span style={{padding: 0}}>{'US'}</span>
                        </>
                    )
                }
            </div>
        </div>
    )
}

export default function MessageSettings({}) {
    const {getSelectedHistory, selectedHistoryId, dispatchProject} = useAppContext()

    return (
        <>
            <div style={{flex: 1}}>
                <div style={{
                    backgroundColor: 'white',
                    padding: 3,
                    height: 38,
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <CrossSectionFilter />
                    <Radio.Group
                        style={{marginLeft: 16}}
                        options={[
                            {label: <DSUS reverse={true}/>, value: 'ds'},
                            {label: <DSUS/>, value: 'us'},
                        ]}
                        onChange={(e) => {
                            const val = e.target.value;

                            dispatchProject({
                                type: AppActions.SET_PAGE_SETTINGS,
                                data: {
                                    page: {
                                        ...getSelectedHistory()?.page,
                                        sort: val
                                    }
                                }
                            })
                        }}
                        value={getSelectedHistory()?.page?.sort}
                        optionType="button"
                        buttonStyle="solid"
                        size={'small'}
                    />
                </div>
            </div>
        </>
    )
}